import React, { Component } from 'react';

class People extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      school: this.props.schools[0].id,
      classroom: ''
    }
  }

  removePerson(id, e){
    e.preventDefault();
    //Delete request
    fetch('/api/people/remove', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify({id: id}),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok){
        var people = this.props.people;
        people = people.filter(s=>s.id !== id);
        this.props.setState({people: people});
      }
      else
        throw new Error('Network response was not ok.');
    })
  }

  handleChange(e){
    var news = {},
      val = ['school'].indexOf(e.target.name) > -1 ?
        parseInt(e.target.value, 10) : e.target.value;
    news[e.target.name] = val;
    this.setState(news);
  }

  handleBack(e){
    e.preventDefault();
    window.history.go(-1);
  }

  newPerson(e){
    e.preventDefault();

    //Do post
    var person = {
      name: this.state.name,
      schoolId: this.state.school,
      classroom: this.state.classroom
    };

    fetch('/api/people', {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(person),
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
    .then(res => {
      if(res.ok)
        return res.json()
      else
        throw new Error('Network response was not ok.');
    })
    .then(res => {
      if(res.error)
        this.setState({error: res.error})
      else {
        var people = this.props.people,
          order = this.props.order;
        people.push(res);
        order.customer = res;

        this.setState({
          name: '',
          school: this.props.schools[0].id
        });

        this.props.setState({
          people: people,
          order: order
        });
      }
    })
    .catch(error=> {
      console.log('error', error);
      this.setState({error: error.toString()})
    });
  }

  submitDisabled(){
    return this.state.name.length < 1;
  }

  render() {
    return (
      <div className="">
        {this.props.first ? null : (
          <div>
            <h1>Manage people</h1>
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>School</th>
                  <th>Class</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                { this.props.people.map(person=>(
                  <tr key={person.id}>
                    <td>{person.name}</td>
                    <td>{person.school.name}</td>
                    <td>{person.classroom && person.classroom.name}</td>
                    <td>
                      <button className="btn btn-sm btn-danger"
                        onClick={this.removePerson.bind(this, person.id)}>x</button>
                    </td>
                  </tr>
                )) }
              </tbody>
            </table>
          </div>
        ) }


        {this.props.first ? (
          <div>
            <h3>Please enter the details of the order recipient</h3>
            <br />
          </div>
        ) : <h2>Add new person</h2> }
        <form className="form-horizontal" onSubmit={this.newPerson.bind(this)}>
          <div className="form-group">
            <label htmlFor="newName" className="col-sm-2 control-label">Full Name</label>
            <div className="col-sm-10">
              <input type="text"
                className="form-control"
                id="newName"
                placeholder="Name"
                name="name"
                value={this.state.name}
                onChange={this.handleChange.bind(this)} />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="newSchool" className="col-sm-2 control-label">School</label>
            <div className="col-sm-10">
              <select className="form-control"
                name="school"
                value={this.state.school}
                onChange={this.handleChange.bind(this)}>
                {
                  this.props.schools.map(school=>(
                    <option key={school.id}
                      value={school.id}>{school.name}</option>
                  ))
                }
              </select>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="newClass" className="col-sm-2 control-label">Class</label>

            <div className="col-sm-10">
              <input type="text"
                className="form-control"
                id="newClass"
                placeholder="Class"
                name="classroom"
                value={this.state.classroom}
                onChange={this.handleChange.bind(this)} />

            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <a href="" onClick={this.handleBack} className="btn btn-default">Back</a>
              &nbsp;
              <button disabled={this.submitDisabled()}
                type="submit" className="btn btn-primary">Save</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default People;



// WEBPACK FOOTER //
// ./src/pages/People.js